import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/index.scss';
import App from 'App';
import reportWebVitals from './reportWebVitals';
import { InputProvider } from 'hooks/useInputKeys';
import { QueryClient, QueryClientProvider } from 'react-query';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeContextProvider } from 'theme/ThemeContextProvider';


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <InputProvider>
        <ThemeContextProvider>
          <App />
        </ThemeContextProvider>
      </InputProvider>
    </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
